import * as yup from 'yup';
import { CustomsInstructionsForHandling } from '../../../../@posturinn/client-react';

export interface IAttachFiles {
	files?: File[];
	additionalInformation?: string;
	customsInstructionsForHandling: CustomsInstructionsForHandling;
	terms?: boolean;
}

export const attachFilesInitialValues: IAttachFiles = {
	files: [],
	additionalInformation: '',
	customsInstructionsForHandling: null,
	terms: false,
};

export const attachFilesSchema = yup.object().shape({
	files: yup.array().of(yup.object().nullable()).min(1, 'required'),
	additionalInformation: yup.string().required('required').max(255, 'tooLong'),
	customsInstructionsForHandling: yup.string(),
	terms: yup.boolean().oneOf([true], 'required').required('required'),
	email: yup.string().email('email-format').required('required'),
});
